import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Bell, ChevronDown } from 'lucide-react';
import { avatarById, DEFAULT_AVATAR } from '../lib/avatars';

const NETFLIX_LOGO = 'https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg';

export default function Navbar({ onSearch }) {
  const [scrolled, setScrolled] = useState(false);
  const [query, setQuery] = useState('');
  const [showSearch, setShowSearch] = useState(false);
  const [avatar, setAvatar] = useState(DEFAULT_AVATAR);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    try {
      const active = JSON.parse(localStorage.getItem('nf_active_profile') || 'null');
      if (active) setAvatar(avatarById(active.avatarId));
    } catch (e) { /* ignore */ }
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = ['Home', 'TV Shows', 'Movies', 'New & Popular', 'My List'];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled ? 'bg-[#141414]' : 'bg-gradient-to-b from-black/80 to-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-12 py-3">
        <div className="flex items-center gap-8">
          <img
            src={NETFLIX_LOGO}
            alt="Netflix"
            className="h-5 md:h-7 cursor-pointer"
            onClick={() => navigate('/browse')}
          />
          <nav className="hidden lg:flex items-center gap-5">
            {links.map((l) => (
              <span
                key={l}
                className="text-sm text-[#e5e5e5] hover:text-white cursor-pointer transition-colors"
              >
                {l}
              </span>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-4 md:gap-5">
          <div className="flex items-center">
            {showSearch && (
              <input
                autoFocus
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  onSearch && onSearch(e.target.value);
                }}
                onBlur={() => { if (!query) setShowSearch(false); }}
                placeholder="Titles, people, genres"
                className="bg-black/80 border border-white/40 text-white text-sm px-3 py-1.5 w-40 md:w-56 outline-none rounded-sm"
              />
            )}
            <button
              onClick={() => setShowSearch((s) => !s)}
              className="p-1.5 text-white"
              aria-label="Search"
            >
              <Search size={20} />
            </button>
          </div>
          <span className="hidden md:inline text-sm text-white cursor-pointer">Kids</span>
          <Bell size={20} className="text-white cursor-pointer" />
          <div className="flex items-center gap-1 cursor-pointer" onClick={() => navigate('/')}>
            <img src={avatar} alt="profile" className="w-8 h-8 rounded" />
            <ChevronDown size={16} className="text-white" />
          </div>
        </div>
      </div>
    </header>
  );
}